import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {GroupResourceOption} from '../../../graphql/groups.datatypes';

export interface DeleteGroupResourceOptionInput {
  id: number
}

interface DeleteGroupResourceOptionData {
  deleteGroupResourceOption: GroupResourceOption,
}

export const DELETE_GROUP_RESOURCE_OPTION_MUTATION = gql`
  mutation deleteGroupResourceOption($id: Int!){
    deleteGroupResourceOption(id: $id) {
      id
      mandatory
      editing_level
    }
  }
`;

export const deleteGroupResourceOption = () => {
  return useMutation<DeleteGroupResourceOptionData, DeleteGroupResourceOptionInput>(
    DELETE_GROUP_RESOURCE_OPTION_MUTATION,
    {
      update: updateCacheByType('GroupResourceOption'),
    }
  );
};

export default deleteGroupResourceOption;